import * as React from 'react';
import { useEffect, useContext } from 'react';
import {
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { UserContext } from '../store/userContext';
import UserListMobile from './UserListMobile';
import loadingUsers from './loadingUsers';
import DesktopList from '../utils/components/DesktopList';
import UserForm from './UserForm';
import UserRow from './UserRow';

const UserList: React.FC = () => {
  const {
    getUsers,
    users,
    getUsersLoading,
    addUser,
    addUserLoading,
  } = useContext(UserContext);
  const theme = useTheme();
  const isMediumOrSmaller = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation('users');

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  return (
    <Container maxWidth="lg">
      <Typography
        align="center"
        color="secondary"
        variant="h3"
        sx={(theme) => ({
          fontWeight: theme.typography.fontWeightBold,
          mb: 4,
          [theme.breakpoints.down('sm')]: {
            fontSize: '2.5rem',
          },
        })}
      >
        {t('users')}
      </Typography>
      {isMediumOrSmaller ? (
        <UserListMobile
          users={getUsersLoading ? loadingUsers : users}
          loading={getUsersLoading}
        />
      ) : (
        <DesktopList<User, UserFormDto>
          headers={['username', 'email', 'role', 'locale', 'sites']}
          data={getUsersLoading ? loadingUsers : users}
          loading={getUsersLoading}
          ns="users"
          add={addUser}
          get={getUsers}
          emptyKey="noUsers"
          renderAddForm={({ onSubmit, buttonText }) => (
            <UserForm
              loading={addUserLoading}
              onSubmit={onSubmit}
              buttonText={buttonText}
            />
          )}
          renderBody={({ data, loading, columnCount }) => (
            <UserRow
              key={data.id}
              user={data}
              loading={loading}
              colCount={columnCount}
            />
          )}
          showAdd
        />
      )}
    </Container>
  );
};

export default UserList;
